import Head from "next/head";

import { CityInfo } from "@/api/requests/getCityStateGeocode";
import { FAQ } from "@/custom-types/Directus";
import useDomain from "@/hooks/useDomain";

const DeliveryHead: React.FC<{
  metadata: FAQ | null;
  geoCityResult?: CityInfo;
}> = ({ metadata, geoCityResult }) => {
  const domain = useDomain();

  const cityStateText =
    geoCityResult?.city && geoCityResult?.state
      ? `in ${geoCityResult.city}, ${geoCityResult.state}`
      : geoCityResult?.state
        ? `in ${geoCityResult.stateLong}`
        : "Near You";

  const canonicalUrl =
    geoCityResult?.citySlug && geoCityResult?.stateSlug
      ? `${domain}/delivery/${geoCityResult.stateSlug}/${geoCityResult.citySlug}`
      : geoCityResult?.stateSlug
        ? `${domain}/delivery/${geoCityResult.stateSlug}`
        : `${domain}/delivery`;

  return (
    <Head>
      <title>
        {metadata?.meta_title ||
          `Weed Delivery | Same-day Cannabis Delivery ${cityStateText} | Leafly`}
      </title>
      <meta
        name="description"
        content={
          metadata?.meta_description ||
          `Find the best weed delivery dispensaries ${cityStateText} with Leafly. Order weed for same-day delivery, find reviews & menus from the top dispensaries.`
        }
      />

      <link rel="canonical" href={canonicalUrl} />

      {!geoCityResult && (
        <>
          <link
            rel="alternate"
            hrefLang="en-us"
            href="https://www.leafly.com/delivery"
          />
          <link
            rel="alternate"
            hrefLang="en-ca"
            href="https://www.leafly.ca/delivery"
          />
        </>
      )}
    </Head>
  );
};

export default DeliveryHead;
